import { DateTime } from "luxon";

export class DatePipe {
  
  static transform(value, format){
    if (value == null || value === '' || value !== value) return null;
    if (typeof value === 'string') {
      value = value.trim();
    }
    let date;
    if (typeof value === 'number') {
      date = new Date(value);
    } else if (value instanceof Date) {
      date = value;
    } else {
      date = new Date(value);
      if (isNaN(date.getTime())) {
        throw new Error(`InvalidPipeArgument: '${value}' for pipe 'DatePipe'`);
      }
    }
    return formatDate(date, format || 'mediumDate', 'en');//this.locale
  }
}
export function formatDate(value,  format, locale, timezone = null){
  const date = toDate(value);
  if (!isValid(date)) {
    throw new Error('Invalid Date');
  }
  return formatDateTime(date, locale, format, timezone);
}
export function toDate(value) {
  if (value instanceof Date) {
    return value;
  } else if (typeof value === 'number' || typeof value === 'string' || value == null) {
    const timestamp = Date.parse(value);
    return isNaN(timestamp) ? null : new Date(timestamp);
  } else {
    throw new Error(`Invalid date '${value}'`);
  }
}
export function isValid(value){
  if (value instanceof Date && !isNaN(value.getTime())) {
    return true;
  } else if (typeof value === 'number' || typeof value === 'string') {
    const timestamp = Date.parse(value);
    return !isNaN(timestamp);
  } else {
    return false;
  }
}
export function formatDateTime( date,locale,format,timezone = null){
  const options = {
    localeMatcher: 'best fit',
    timeZone: timezone,
  };

  const dt = DateTime.fromJSDate(date, options);
  const tz = extractTimezone(dt, timezone);

  //return dt.setZone(tz).toLocaleString(DateTime.DATETIME_FULL_WITH_SECONDS);
  return dt.setZone(tz).toFormat(format);
}
export function extractTimezone(dateTime, timeZone = null) {
  if (timeZone) {
    return timeZone;
  } else if (dateTime.offset === 0) {
    return 'UTC';
  } else {
    return dateTime.zoneName;
  }
}

//DateInput